export default __webpack_public_path__ + "static/media/resume_btn.a7921039.png";